// Copyright 2022 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license, please see LICENSE.md in the
// project root for license information or contact permission@sei.cmu.edu for full terms.

import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { CiteDuty } from 'src/app/generated/blueprint.api';
import { Injectable } from '@angular/core';

export interface CiteDutyState extends EntityState<CiteDuty> {}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'citeDuties' })
export class CiteDutyStore extends EntityStore<CiteDutyState> {
  constructor() {
    super();
  }
}
